<template>
    <div
        :class="{
            'card-course-wrapper': true,
            'card-course-wrapper--active': expandedEntityId === course.id,
        }"
    >
        <div class="card-course" @click="goToCourse">
            <div class="card-course__favorite-btn">
                <FavoriteToggle :entityId="course.id" entityType="events" />
            </div>
            <div class="card-course__wrapper-image">
                <img v-if="courseImage" class="card-course__image" :src="courseImage" alt="course" />
                <div
                    v-if="statusMap[course.userStatus] && !hideStatus"
                    class="card-course__status"
                    :style="{
                        color: statusMap[course.userStatus].textColor,
                        backgroundColor: statusMap[course.userStatus].bgColor,
                    }"
                >
                    {{ statusMap[course.userStatus].text }}
                </div>
            </div>
            <h3 class="card-course__title">{{ course.name }}</h3>
            <TagsDropdown
                :entityId="course.id"
                :expandedEntityId="expandedEntityId"
                :foreignCompetenceIds="course.foreignCompetenceIds"
                :foreignCourseAreasId="course.foreignCourseAreasId"
                @onExpandedTags="$emit('onExpandedTags', course.id)"
            />
        </div>
    </div>
</template>

<script>
import FavoriteToggle from './components/FavoriteToggle.vue';
import TagsDropdown from './components/TagsDropdown.vue';

export default {
    name: 'CardCourse',
    components: {
        FavoriteToggle,
        TagsDropdown,
    },
    props: {
        course: {
            type: Object,
            required: true,
        },
        expandedEntityId: {
            type: [String, Number],
            default: null,
        },
        hideStatus: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            statusMap: {
                admin_sent_request: {
                    text: 'Приглашен',
                    textColor: '#fff',
                    bgColor: 'rgba(105, 96, 159, 1)',
                },
                user_sent_request: {
                    text: 'Ожидает подтверждения',
                    textColor: '#fff',
                    bgColor: 'rgba(232, 178, 41, 1)',
                },
                admin_confirmed_request: {
                    text: 'Участник',
                    textColor: '#fff',
                    bgColor: 'rgba(70, 99, 171, 1)',
                },
                user_confirmed_request: {
                    text: 'Участник',
                    textColor: '#fff',
                    bgColor: 'rgba(70, 99, 171, 1)',
                },
                completed_event: {
                    text: 'Пройдено',
                    textColor: '#fff',
                    bgColor: 'rgba(104, 200, 122, 1)',
                },
                missed_event: {
                    text: 'Пропущено',
                    textColor: '#fff',
                    bgColor: 'rgba(219, 108, 97, 1)',
                },
                subscribed: {
                    text: 'Подписан',
                    textColor: '#fff',
                    bgColor: 'rgba(160, 200, 234, 1)',
                },
            },
        };
    },
    computed: {
        courseImage() {
            return this.course.cover ? this.course.cover.url : '';
        },
    },
    methods: {
        goToCourse() {
            window.open(`https://${window.rsvDomain}/education/course/1/${this.course.id}`, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.card-course-wrapper {
    position: relative;
    height: urem(381);
    width: 100%;

    &--active {
        z-index: 2;
    }

    @include on-desktop {
        height: urem(354);
        width: urem(252);
    }
}

.card-course {
    width: 100%;
    min-height: urem(381);
    background-color: rgba(255, 255, 255, 1);
    font-size: urem(16);
    font-weight: 400;
    color: rgba(42, 38, 38, 1);
    box-shadow: 0 0 urem(20) 0 rgba(70, 99, 171, 0.2);
    position: relative;
    font-family: $font-montserrat;
    border-radius: urem(16);
    display: flex;
    flex-direction: column;
    z-index: 1;

    cursor: pointer;

    @include on-desktop {
        min-height: urem(354);
        width: urem(252);
    }

    * {
        font-family: inherit;
    }

    &__title {
        font-size: urem(14);
        font-weight: 700;
        color: black;
        line-height: urem(20);
        margin: 0;
        line-clamp: 3;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        padding: urem(16);
        height: urem(72);

        @include on-desktop {
            height: urem(90);
        }
    }

    &__favorite-btn {
        position: absolute;
        top: urem(5);
        right: urem(5);
        z-index: 2;
    }

    &__wrapper-image {
        width: 100%;
        height: urem(189);
        position: relative;
        z-index: 1;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);

            border-top-left-radius: urem(16);
            border-top-right-radius: urem(16);
            z-index: 0;
        }

        @include on-desktop {
            height: urem(142);
        }
    }

    &__image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-top-left-radius: urem(16);
        border-top-right-radius: urem(16);
    }

    &__status {
        z-index: 3;
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: white;
        height: urem(20);
        padding: 0 urem(8);
        border-top-left-radius: urem(16);
        font-size: urem(10);
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
